module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-e9dbe062f128eeb3b39110689a556eb0.svg";